import React from "react";
import {
  ArrowRight,
  Envelope,
  Linkedin,
  Twitter,
} from "react-bootstrap-icons";

export default function Footer() {
  return (
    <>
      {/* CTA Section */}
      <section className="cta-section text-white py-5">
        <div className="container text-center py-lg-5">
          <h1 className="fw-bold mb-3">
            Ready to Transform Your{" "} <br />
            <span className="textsuccess">Workforce Operations?</span>
          </h1>

          <p className="lead mb-4">
            Let's discuss how 5 Helms Consulting can help optimize your
            implementation and drive operational excellence across your
            organization.
          </p>

          <div className="d-flex justify-content-center gap-3 flex-wrap mb-4">
            <button className="btn btn-light px-4 py-2 fw-semibold">
              Schedule Consultation <ArrowRight className="ms-2" />
            </button>

            <button className="btn btn-outline-light px-4 py-2 fw-semibold">
              Request Quote
            </button>
          </div>

          <p className="mb-0">
            <Envelope className="me-2" />
            UKGExpert@5helms.com
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer-section text-light pt-5">
        <div className="container">
          <div className="row gy-4">
            {/* Company Info */}
            <div className="col-lg-4">
              <a className="navbar-brand fw-bold d-flex align-items-center " href="/">
                <img style={{ width: "60px", marginRight: "10px", filter: "brightness(0) invert(1)" }}
                  src="/img/logo.png"
                  alt="logo"
                   
                />
                5 Helms Consulting
              </a>

              {/* <h5 className="fw-bold mb-3"> 5Helms</h5> */}
              <br /> 
              <p className="text-muted white">
                Expert workforce management implementation and support
                services. Transforming operations for organizations worldwide.
              </p>
            </div>

            {/* Quick Links */}
            <div className="col-lg-4 col-md-6">
              <h6 className="fw-bold mb-3">Quick Links</h6>
              <ul className="list-unstyled">
                <li className="mb-2"><a className="nav-link" href="#services">Services </a></li>
                <li className="mb-2"><a className="nav-link" href="#why-us">Why Us</a></li>
                <li className="mb-2"><a className="nav-link" href="#about">About</a></li>
                <li className="mb-2"><a className="nav-link" href="#contact">Contact</a></li>
              </ul>
            </div>

            {/* Service Pathways */}
            <div className="col-lg-4 col-md-6">
              <h6 className="fw-bold mb-3">Service Pathways</h6>
              <ul className="list-unstyled">
                <li className="mb-2"> <a className="nav-link" href="#services">  Launch Pathway </a></li>
                <li className="mb-2"><a className="nav-link" href="#services">Stabilize Pathway </a></li>
                <li className="mb-2"><a className="nav-link" href="#services">Optimize Pathway </a></li>
                <li className="mb-2"><a className="nav-link" href="#services">Scale Pathway </a></li>
              </ul>
            </div>
          </div>

          <hr className="border-secondary my-4" />

          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="mb-0 small text-muted white">
              © 2025 5Helms. All rights reserved.
            </p>

            <div className="d-flex gap-3">
              <a href="#" className="text-light">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-light">
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
